import { useState } from "react";


const useDialog = () => {
    const [open, setOpen] = useState<boolean>(false);

    return {
        open,
        handleOpen: () => setOpen(true),
        handleClose: () => setOpen(false)
    };
}

export default useDialog;